import React, { useMemo, useState } from "react";
import { Container, Tabs, Tab, Accordion } from "react-bootstrap";
import useIsDesktop from "../../../hooks/useIsDesktop";
import SpecificationTab from "./SpecificationTab";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import "./VehicleSpecificationsSection.css";

export default function VehicleSpecificationsSection({ vehicle }) {
    const isDesktop = useIsDesktop();

    const variants = vehicle?.specVariants || [];
    const categories = vehicle?.specifications || [];

    const defaultKey = useMemo(() => categories[0]?.id || "0", [categories]);

    const [activeKey, setActiveKey] = useState(defaultKey);

    if (!variants.length || !categories.length) return null;

    return (
        <section className="vehicle-specs section-spacing">
            <Container fluid>
                <div className="vehicle-specs__header text-center">
                   
                    <SectionTitle
                        subtitle="Specifications"
                        title="For Mastered Engineering"
                    />

                    <p className="brand-section-desc mb-0">The LANDKING H-Series wasn’t engineered to look good on paper it was built to make paper look small. </p>
                        <p className="brand-section-desc mb-0">Every specification below isn’t just a figure, it’s a benchmark set on Saudi soil.</p>
                        <p className="brand-section-desc">These are the details that separate machines built to last from machines built to survive.</p>
                </div>

                {isDesktop ? (
                    <Tabs
                        activeKey={activeKey}
                        onSelect={(k) => setActiveKey(k)}
                        className="vehicle-specs__tabs"
                        mountOnEnter
                        unmountOnExit
                    >
                        {categories.map((cat) => (
                            <Tab eventKey={cat.id} title={cat.title} key={cat.id}>
                                <div className="vehicle-specs__panel">
                                    <SpecificationTab category={cat} variants={variants} />
                                </div>
                            </Tab>
                        ))}
                    </Tabs>
                ) : (
                    /* ✅ Mobile/Tablet: Accordion */
                    <Accordion defaultActiveKey={defaultKey} className="vehicle-specs__accordion">
                        {categories.map((cat) => (
                            <Accordion.Item eventKey={cat.id} key={cat.id}>
                                <Accordion.Header>{cat.title}</Accordion.Header>
                                <Accordion.Body>
                                    <SpecificationTab category={cat} variants={variants} />
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                )}
            </Container>
        </section>
    );
}
